export default "/images/branding-a.png?f61ce2a600c5f941ac622e1d311ffebf";